module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./LandingPageView.js"));
	}, "ApplicationView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ApplicationView!./src/pages/Shop/Home/LandingPage/LandingPageView.js
// module id = 912
// module chunks = 438